import { render, staticRenderFns } from "./OrdersAudit.vue?vue&type=template&id=46fcc74a&scoped=true"
import script from "./OrdersAudit.vue?vue&type=script&lang=js"
export * from "./OrdersAudit.vue?vue&type=script&lang=js"
import style0 from "./OrdersAudit.vue?vue&type=style&index=0&id=46fcc74a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fcc74a",
  null
  
)

export default component.exports